import { render } from "./dialog-message-feed.component.vue?vue&type=template&id=ca4a7700"
import script from "./dialog-message-feed.component.vue?vue&type=script&lang=js"
export * from "./dialog-message-feed.component.vue?vue&type=script&lang=js"

import "./dialog-message-feed.component.vue?vue&type=style&index=0&id=ca4a7700&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__